<template>
  <el-dialog
    :title="`${model.category == 2 ? '配件' : '成品'}${
      model.status == 5 ? '灭失' : '报废'
    }`"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      v-if="visible"
      ref="form"
      size="small"
      label-width="80px"
      :model="model"
      :rules="rules"
      class="fix-width"
    >
      <el-form-item label="编号" class="long">
        <div v-for="code in model.names" :key="code">{{ code }}</div>
      </el-form-item>
      <el-form-item label="附件" class="long" prop="attachments">
        <AttachmentUpload
          v-model="model.attachments"
          @input="$refs.form.validate()"
        ></AttachmentUpload>
      </el-form-item>
      <el-form-item label="备注" class="long">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>
  
  <script>
import { itemScrap, productScrap } from '@/service/getData'
import AttachmentUpload from './AttachmentUpload.vue'
export default {
  components: {
    AttachmentUpload,
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        attachments: [
          {
            type: 'array',
            required: true,
            message: '请选择附件',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res
          if (this.model.category == 2) {
            res = await itemScrap(this.model)
          } else {
            res = await productScrap(this.model)
          }
          this.submiting = false
          if (res.code == 0) {
            this.$emit('callback')
            this.visible = false
          }
        }
      })
    },
  },
}
</script>